import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import LocationParentsView from './ui/LocationParentsView';
import AudioList from './AudioList';
import StanzaList from './StanzaList';
import PoemList from './PoemList';
import SagnirPersonList from './SagnirPersonList';
import InterviewList from './InterviewList';
import LettersList from './LettersList';
import PersonEventsList from './PersonEventsList';
import MapView from './MapView';
import LocationPersonList from './LocationPersonList';
import PersonList from './PersonList';
import SongList from './SongList';
import PersonGroupsList from './PersonGroupsList';
import Breadcrumb from './ui/Breadcrumb';
import TabContainer from './ui/TabContainer';
import ImageList from './ui/ImageList';
import LoadingBar from './ui/LoadingBar';
import BookmarkButton from './ui/BookmarkButton';
import TextDisplay from './ui/TextDisplay';
import LinkList from './ui/LinkList';
import MusicGraphView from './MusicGraphView';
import FolkloreGraphView from './FolkloreGraphView';
import ProjectEntryList from './ProjectEntryList';
import MediaList from './ui/MediaList';
import Info from './ui/Info';
import DataCounter from './ui/DataCounter';
import NotFound from './ui/NotFound';
import LinkedItems from './ui/LinkedItems';
import {Helmet} from "react-helmet";

import _ from 'underscore';

import config from './../config';
import helpers from './../lib/helpers';

class PersonView extends Component {
	constructor(props) {
		super(props);

		this.state = {
			data: null,
			mapData: null,
			hideAudioList: false,
			hideAudioMentionList: false,
			hideStanzaList: false,
			hidePoemList: false,
			hideSagnirList: false,
			hideSagnirMentionList: false,
			hideInterviewList: false,
			hideLettersList: false,
			hideEventsList: false,
			hideLocationsList: false,
			hideGroupsList: false,
			hideFolkloreGraphView: false,
			hideMusicGraphView: false,
			hideInformantsList: false,
			hideSongList: false,
			hideProjectEntryList: false,
			notFound: false,
			loading: true
		};
	}

	componentDidMount() {
		if (this.props.match.params.id) {
			this.fetchData();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		if (this.props.match.params.id != prevProps.match.params.id) {
			this.fetchData();
		}
	}

	fetchData() {
		this.setState({
			hideAudioList: false,
			hideAudioMentionList: false,
			hideStanzaList: false,
			hidePoemList: false,
			hideSagnirList: false,
			hideSagnirMentionList: false,
			hideInterviewList: false,
			hideLettersList: false,
			hideEventsList: false,
			hideLocationsList: false,
			hideGroupsList: false,
			hideFolkloreGraphView: false,
			hideMusicGraphView: false,
			hideInformantsList: false,
			hideSongList: false,
			hideProjectEntryList: false,
			mapData: [],
			notFound: false,
			loading: true
		});

		helpers.fetch(config.apiRoot+'/api/persons/'+this.props.match.params.id, (json) => {
			if (json.notfound) {
				this.setState({
					notFound: true,
					loading: false
				});

				return;
			}

			if (!helpers.isNumber(this.props.match.params.id) && json.id) {
				this.props.history.replace(helpers.routerUrls['einstaklingar']+json.id);

				return;
			}
			this.setState({
				data: json,
				loading: false
			});
		});
	}

	render() {
		if (this.state.notFound) {
			return <NotFound />
		}
		else {
			let data = this.state.data;

			let tabs = <TabContainer useRouter={'true'} selectedTab={this.props.match.params.tab} baseUrl={helpers.routerUrls['einstaklingar']+this.props.match.params.id}>
				<AudioList tabtitle={'Hljóðrit'}
					tabname="hljodrit"
					heimildarmadur={this.props.match.params.id}
					disablePlayButtonRouteChange={true}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideAudioList}
					onResponse={(response) => {
						this.setState({
							hideAudioList: response.length == 0 || !response
						});
				   }}
				>
					<p><small>
						<DataCounter url={'/api/audio/?limit=1&source='+this.props.match.params.id} onResponse={(count) => {
							return <React.Fragment>{'Heimildarmaður/flytjandi '+count+' hljóðrita: '}<Link className="mr-3" to={helpers.routerUrls['hljodrit']+'?heimildarmadur='+this.props.match.params.id}>sjá öll</Link></React.Fragment>
						}} />
						<DataCounter url={'/api/audio/?limit=1&interviewer='+this.props.match.params.id} onResponse={(count) => {
							return <React.Fragment>{'Spyrill/hljóðritari '+count+' hljóðrita: '}<Link className="mr-3" to={helpers.routerUrls['hljodrit']+'?hljodritari='+this.props.match.params.id}>sjá öll</Link></React.Fragment>
						}} />
					</small></p>
				</AudioList>

				<AudioList tabtitle={'Minnst á í hljóðritum'}
					tabname="hljodrit_minnst_a"
					minnst_a_einstakling={this.props.match.params.id}
					disablePlayButtonRouteChange={true}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideAudioMentionList}
					onResponse={(response) => {
						this.setState({
							hideAudioMentionList: response.length == 0 || !response
						});
				   }}
				>
					<p><small>
						Hljóðrit þar sem minnst er á þennan einstakling.
					</small></p>
				</AudioList>

				<SagnirPersonList tabtitle={'Sagnir og ævintýri'}
					tabname="tjodfraedi"
					personId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideSagnirList}
					onResponse={(response) => {
						this.setState({
							hideSagnirList: response.length == 0 || !response
						});
				   }}
				>
					<p className="mb-3"><small>Heimildarmaður/skrásetjari eftirfarandi þjóðfræðiefnis.</small></p>
					<p><small>
						<DataCounter url={'/api/folklore/?limit=1&informant='+this.props.match.params.id} onResponse={(count) => {
							return <React.Fragment>{'Heimildarmaður '+count+' sagna/ævintýra: '}<Link className="mr-3" to={helpers.routerUrls['sagnir_aevintyri']+'?heimildarmadur='+this.props.match.params.id}>sjá allar</Link></React.Fragment>
						}} />
						<DataCounter url={'/api/folklore/?limit=1&recorder='+this.props.match.params.id} onResponse={(count) => {
							return <React.Fragment>{'Skrásetjari/sendandi '+count+' sagna/ævintýra: '}<Link className="mr-3" to={helpers.routerUrls['sagnir_aevintyri']+'?skrasetjari='+this.props.match.params.id}>sjá allar</Link></React.Fragment>
						}} />
					</small></p>
				</SagnirPersonList>

				<SagnirPersonList tabtitle={'Minnst á í sögnum'}
					tabname="tjodfraedi_minnst_a"
					mentionId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideSagnirMentionList}
					onResponse={(response) => {
						this.setState({
							hideSagnirMentionList: response.length == 0 || !response
						});
				   }}
				>
					<p className="mb-3"><small>Minnst á í sögnum.</small></p>
				</SagnirPersonList>

				<InterviewList tabtitle={'Viðtöl'}
					tabname="vidtol"
					sourceId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideInterviewList}
					onResponse={(response) => {
						this.setState({
							hideInterviewList: response.length == 0 || !response
						});
				   }}
			   >
					<p className="mb-3"><small>Viðmælandi í viðtölum.</small></p>
				</InterviewList>

				<LettersList tabtitle={'Bréf'}
					tabname="bref"
					personId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideLettersList}
					onResponse={(response) => {
						this.setState({
							hideLettersList: response.length == 0 || !response
						});
				   }}
			   >
					<p className="mb-3"><small>Viðtakandi eða sendandi bréfa.</small></p>
				</LettersList>

				<PersonEventsList tabtitle={'Viðburðir'}
					tabname="vidburdir"
					personId={this.props.match.params.id}
					hideAsTab={this.state.hideEventsList}
					onResponse={(response) => {
						this.setState({
							hideEventsList: response.length == 0 || !response
						});
				   }}
			   >
					<p className="mb-3"><small>Þáttakandi í viðburðum.</small></p>
				</PersonEventsList>

				<PersonGroupsList tabtitle={'Hópar'}
					tabname="hopar"
					personId={this.props.match.params.id}
					hideAsTab={this.state.hideGroupsList}
					onResponse={(response) => {
						this.setState({
							hideGroupsList: response.length == 0 || !response
						});
					}}
				>
					<p className="mb-3"><small>Meðlimur í hópum.</small></p>
				</PersonGroupsList>

				{
					data && data.music_person &&
					<MusicGraphView tabtitle={'Tengslanet innan tónlistar'}
						tabname="tengsltonlist"
						hideAsTab={this.state.hideMusicGraphView}
						personId={this.props.match.params.id}
						onResponse={(response) => {
							this.setState({
								hideMusicGraphView: response.nodes.length == 0 || !response
							});
					   }}
					>
						<p className="mb-3"><small>Tónlistarhópar sem {data.name} tilheyrir og aðrir meðlimir hópanna.</small></p>
					</MusicGraphView>
				}

			
				<PersonList tabtitle={'Heimildarmenn'}
					tabname="heimildarmenn"
					folkloreRecorderId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideInformantsList}
					onResponse={(response) => {
						this.setState({
							hideInformantsList: response.length == 0 || !response
						});
					}}
				>
					<p className="mb-3"><small>Heimildarmenn sagna og ævintýra.</small></p>
				</PersonList>


				{
					data && data.folklore_person &&
					<FolkloreGraphView tabtitle={'Tengslanet þjóðfræði'}
						tabname="tengsltjodfraedi"
						hideAsTab={this.state.hideFolkloreGraphView}
						personId={this.props.match.params.id}
						onResponse={(response) => {
							this.setState({
								hideFolkloreGraphView: response.nodes.length == 0 || !response
							});
					   }}
					>
						<p className="mb-3"><small>Heimildarmenn, spyrlar og safnarar þjóðfræðiefnis sem {data.name} tengist og möguleg bréf sem {data.name} sendi eða tók við.</small></p>
					</FolkloreGraphView>
				}

				<LocationPersonList tabtitle={'Staðir'}
					tabname="stadir"
					personId={this.props.match.params.id}
					hideAsTab={this.state.hideLocationsList}
					searchParams={this.props.searchParams}
					onResponse={(response) => {
						this.setState({
							hideLocationsList: response.length == 0 || !response
						});

						if (response.length > 0) {
							let mapData = [];

							response.forEach((item, i) => {
								if (item.location && item.location.lat && item.location.lng) {
									mapData.push({
										id: item.location.id,
										label: item.location.name,
										latLng: [item.location.lat, item.location.lng],
										district: helpers.createLocationParentString(item.location.parent)
									});
								}
							});

							this.setState({
								mapData: mapData
							});
						}
				   }}
				>
					<p className="mb-3"><small>Staðir tengdir þessum einstaklingi.</small></p>
					{
						this.state.mapData && this.state.mapData.length > 0 &&
						<MapView className="small" mapData={this.state.mapData} />
					}

				</LocationPersonList>

				<StanzaList tabtitle={'Lausavísur'}
					tabname="erindi"
					authorId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hideStanzaList}
					onResponse={(response) => {
						this.setState({
							hideStanzaList: response.length == 0 || !response
						});
				   }}
				>
					<p className="mb-3">Höfundur eða þýðandi eftirfarinna lausavísna. <Link to={helpers.routerUrls['erindi']+'?hofundur='+this.props.match.params.id}>Sjá allar lausavísur í Braga.</Link></p>
				</StanzaList>

				<PoemList tabtitle={'Ljóð'}
					tabname="ljod"
					authorId={this.props.match.params.id}
					searchParams={this.props.searchParams}
					hideAsTab={this.state.hidePoemList}
					onResponse={(response) => {
						this.setState({
							hidePoemList: response.length == 0 || !response
						});
				   }}
				>
					<p className="mb-3">Höfundur eða þýðandi eftirfarinna ljóða. <Link to={helpers.routerUrls['ljod']+'?hofundur='+this.props.match.params.id}>Sjá öll ljóð í Braga.</Link></p>
				</PoemList>

				<SongList person={this.props.match.params.id}
					tabname="log"
					tabtitle="Lög"
					hideAsTab={this.state.hideSongList}
					searchParams={this.props.searchParams}
					onResponse={(data) => {
						this.setState({
							hideSongList: data.length == 0
						})
					}}
				>
					<p className="mb-3"><small>Safnari, skrásetjari eða heimildarmaður laga.</small></p>
				</SongList>

				{
					data && data.links && data.links.length > 0 &&
					<LinkList tabtitle={'Tenglar'}
						tabname="tenglar"
						data={data.links}>
						<p className="mb-3"><small>Tengt efni á öðrum vefjum.</small></p>
					</LinkList>
				}

				{
					data && data.files && _.reject(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png').length > 0 &&
					<MediaList tabtitle={'Tengdar skrár'}
						tabname="skrar"
						data={_.reject(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png')}>
						<p className="mb-3"><small>Tengdar skrár.</small></p>
					</MediaList>
				}

				<ProjectEntryList tabtitle={'Verkefnisgögn'}
					tabname="verkefni"
					personId={this.props.match.params.id}
					hideAsTab={this.state.hideProjectEntryList}
					onResponse={(data) => {
						this.setState({
							hideProjectEntryList: data.length == 0
						});
					}}
				>
					<p className="mb-3"><small>Verkefnisgögn tengd þessum einstaklingi.</small></p>
				</ProjectEntryList>

				{
					data && data.person_sources && data.person_sources.length > 0 &&
						<div tabtitle={'Heimildir'} tabname="heimildir">
							<table className="table">
								<thead>
									<tr>
										<th>Heimild</th>
										<th>Síða</th>
										<th>Bindi</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{
										data.person_sources && data.person_sources.map((page, index) => <tr key={index}>
											<td>
												{
													((book) => {
														return <Link to={helpers.routerUrls['baekur']+book.id+(page.page && page.page.id ? '/myndir?syna='+page.page.id : '')}>
															{(book.number || '')+(book.name ? (book.name && book.number ? ' ('+book.name+')' : book.name) : '')}
														</Link>
													})(page.book)
												}
											</td>
											<td>
												{
													(page.page_name && page.page_name != page.page_number) ? page.page_name : page.page_number
												}
											</td>
											<td>
												{
													page.volume
												}
											</td>
											<td>
												{
													page.source_info && <p> <i dangerouslySetInnerHTML={{__html: page.source_info}} /></p>
												}
											</td>
										</tr>)
									}
								</tbody>
							</table>
						</div>
					}

			</TabContainer>;

			return <div className={'content-container position-relative '+(this.state.loading ? ' loading' : '')}>
				<LoadingBar />
				{
					data &&
					<React.Fragment>

						<Helmet>
							<meta property="og:type"
								content="article"
							/>
							<meta property="og:title"
								content={'Ísmús | '+data.name}
							/>
							{
								data.life && 
								<meta property="og:description"
									content={helpers.trim(data.life, data.life.length)}
								/>
							}
							{
								data.files && data.files.length > 0 && _.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png').length > 0 &&
								<meta property="og:image"
									content={config.mediaUrl+_.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png')[0].path}
								/>
							}
							{
								!(data.files && data.files.length > 0 && _.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png').length > 0) &&
								<meta property="og:image" content='//ismus.is/img/share-image.png' />
							}
						</Helmet>

						<Breadcrumb currentElTitle={data.name} />

						<div>
							<BookmarkButton id={data.id} title={data.name} type="person" className="float-right" />
							<h2>{data.name}
								{
									data.aka &&
									<React.Fragment>
										<br/>
										<small>{data.aka.split('\n').join(', ')}</small>
									</React.Fragment>
								}
							</h2>
							{
								data.ambiguous &&
								<Info>Þessi færsla táknar óskilgreindan einstakling. Þetta getur verið óþekkt persóna eða ákveðinn hópur, til dæmis „Sagnir úr Svarfaðardal“ eða „Gömul kona í Borgarfirði“.</Info>
							}
						</div>

						<div className="row mt-5">

							<div className="col-12 col-md-8">

								{
									data.life && data.life.length > 0 &&
									<TextDisplay className="mt-4" maxHeight={500} text={data.life} />
								}
								{
									(!data.life || data.life.length == 0) &&
									tabs
								}

							</div>

							<div className="col-12 col-md-4">
								{
									data.files && data.files.length > 0 && _.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png').length > 0 &&
									<ImageList data={_.filter(data.files, (item) => item.path.endsWith('.jpg') || item.path.endsWith('.png') || item.extension == 'jpg' || item.extension == 'png')} />
								}

								<table className="table metadata-table">
									<tbody>
										{
											data.status && data.status.length > 0 &&
											<tr><td colSpan="2">{helpers.metadataList(data.status, helpers.routerUrls['einstaklingar'], 'id', 'name', 'stada', true)}</td></tr>
										}
										{
											data.date_of_birth &&
											<tr><td><label>Fæðingardagur</label></td><td>{helpers.formatDate(data.date_of_birth)}</td></tr>
										}
										{
											data.date_of_death &&
											<tr><td><label>Dánardagur</label></td><td>{helpers.formatDate(data.date_of_death)}</td></tr>
										}
										{
											data.origin &&
											<tr><td><label>Uppruni</label></td><td><LocationParentsView location={data.origin} /></td></tr>
										}
										{
											data.address &&
											<tr><td><label>Heimili</label></td><td><LocationParentsView location={data.address} /></td></tr>
										}
										<DataCounter url={'/api/audio/?limit=1&interviewer='+data.id} onResponse={(count) => {
											return <tr><td><label>Hljóðritari/spyrill</label></td><td><Link to={helpers.routerUrls['hljodrit']+'?hljodritari='+data.id}>{count+' hljóðrit'}</Link></td></tr>
										}} />
										{
											data.location &&
											<React.Fragment>
												<tr><td><label>Tengdir staðir</label></td><td>
													{
														data.location.map((location, index) => <React.Fragment>
															{
																index > 0 && <hr/>
															}
															<LocationParentsView key={index} location={location} />
														</React.Fragment>)
													}
												</td></tr>
											</React.Fragment>
										}
									</tbody>
								</table>

							</div>

						</div>

						{
							data.life && data.life.length > 0 &&
							tabs
						}

						{
							_.filter(data.external_id, (item) => item.source != 'sagnagrunnur').length > 0 &&
							<LinkedItems>
								{
									_.filter(data.external_id, (item) => item.source != 'sagnagrunnur').map((item, index) => {
										return <span className="mr-3">
											{
												item.source == 'lbs' &&
												<a href={'https://handrit.is/is/biography/view/'+item.id}>Handrit.is ({item.id})</a>
											}
											{
												item.source == 'nodegoat' &&
												<span className="mr-3">
													<a href={'http://show.ernie.uva.nl/'+item.id}>Encyclopedia of Romantic Nationalism in Europe</a>
												</span>
											}
										</span>
									})
								}
							</LinkedItems>
						}

						{
							data.modification_date &&
							<p className="mt-4 small">Síðast breytt {helpers.formatDate(data.modification_date, false, true)}</p>
						}

					</React.Fragment>
				}
			</div>
		}
	}
}

export default withRouter(PersonView);
